import { getCoprincipalAccountSourcesByBootState, BootState } from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';
import { isPstFileMailboxInfo } from 'owa-client-types/lib/PstFileMailboxInfo';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Existing isFeatureEnabled usage — migrate to isGlobalFeatureEnabled or isAccountFeatureEnabled
 *	> 'isFeatureEnabled' import from 'owa-feature-flags' is restricted. Use isGlobalFeatureEnabled or isAccountFeatureEnabled from owa-feature-flags instead */
import { type FeatureName, isFeatureEnabled, isGlobalFeatureEnabled } from 'owa-feature-flags';

export enum DiagnosticsFeature {
    Feedback = 'feedback',
    InAppSupport = 'inappsupport',
    GetDiagnostics = 'getdiagnostics',
}

export function getAggregateFeedbackSupportFeatureFlag(
    diagnosticsFeature: DiagnosticsFeature
): boolean {
    if (isGlobalFeatureEnabled('mon-diag-enableAggregateDiagnsoticsFeatureFlagCheck')) {
        const accounts = getCoprincipalAccountSourcesByBootState(BootState.StartupComplete).filter(
            account => !isPstFileMailboxInfo(account.mailboxInfo)
        );
        let featureFlight: FeatureName = 'mon-diag-feedbackjs';
        switch (diagnosticsFeature) {
            case DiagnosticsFeature.Feedback:
                featureFlight = 'mon-diag-feedbackjs';
                break;

            case DiagnosticsFeature.InAppSupport:
                featureFlight = 'mon-diag-inappsupport';
                break;

            case DiagnosticsFeature.GetDiagnostics:
                featureFlight = 'mon-diag-getDiagnostics';
                break;
        }

        let isDiagnosticsFeatureEnabled = true; // true by default

        /* eslint-disable-next-line owa-custom-rules/forbid-foreach-with-variables-outside-of-function-scope -- (https://aka.ms/OWALintWiki)
         * https://dev.azure.com/outlookweb/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9650/Use-for-const-loop-of-instead-of-forEach
         *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead
         *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead */
        accounts.forEach(account => {
            const mailboxInfo = account.mailboxInfo;

            isDiagnosticsFeatureEnabled =
                /* eslint-disable-next-line owa-custom-rules/require-undefined-parameter -- (https://aka.ms/OWALintWiki)
                 * Flight checks that supply MailboxInfo should be defined as AccountFeatureName value and should be checked using isAccountFeatureEnabled to ensure consistent checking.
                 *	> The parameter mailboxInfo must be undefined. Feature flight: featureFlight */
                isDiagnosticsFeatureEnabled && isFeatureEnabled(featureFlight, mailboxInfo);
            /* eslint-disable-next-line owa-custom-rules/forbid-specific-functions-patterns-inside-loops -- (https://aka.ms/OWALintWiki)
             * Baseline, this function can't be used inside a loop, please move it outside
             *	> Function 'logUsage' matches forbidden pattern (/logUsage/) and should not be used inside loops */
            logUsage('DiagnosticsAndSupport_IsDiagnosticsFeatureFlagEnabled', mailboxInfo, {
                accountType: mailboxInfo.type,
                isFeedbackFeatureFlagEnabled: isDiagnosticsFeatureEnabled,
                entrypoint: diagnosticsFeature,
                /* eslint-disable-next-line owa-custom-rules/require-undefined-parameter -- (https://aka.ms/OWALintWiki)
                 * Flight checks that supply MailboxInfo should be defined as AccountFeatureName value and should be checked using isAccountFeatureEnabled to ensure consistent checking.
                 *	> The parameter mailboxInfo must be undefined. Feature flight: featureFlight */
                isFeedbackFlightEnabled: isFeatureEnabled(featureFlight, mailboxInfo),
            });
        });

        return isDiagnosticsFeatureEnabled;
    }

    return false;
}
